import {
  DOMAIN_LIST_SEARCH, DOMAIN_LIST_SEARCH_FAILURE, DOMAIN_LIST_SEARCH_SUCCESS, DOMAIN_DELETE, DOMAIN_DELETE_FAILURE, DOMAIN_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    domains: [],
    domainListNextPage: null,
    domainListCurrentPage: null
  },
  getters: {
    domainList: state => {
      return state.domains
    },
    domainListNextPage: state => {
      return state.domainListNextPage
    },
    domainListCurrentPage: state => {
      return state.domainListCurrentPage
    }
  },
  actions: {
    [DOMAIN_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/domains'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DOMAIN_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(DOMAIN_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [DOMAIN_DELETE] ({dispatch, state, commit}, params = null) {
      console.log('DOMAIN_DELETE:' + params.id)
      var data = params.data
      var url = '/master/domains/' + params.id
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(DOMAIN_DELETE_FAILURE, res.data)
          } else {
            commit(DOMAIN_DELETE_SUCCESS, {data: res.data, callback: params.callback})
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [DOMAIN_LIST_SEARCH_FAILURE] (state, params) {
      console.log('DOMAIN_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [DOMAIN_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('DOMAIN_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.domains = state.domains.concat(data.data)
        state.domainListCurrentPage = data.meta['current-page']
      } else {
        state.domains = data.data
        state.domainListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.domainListNextPage = data.links['next']
      } else {
        state.domainListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    },
    [DOMAIN_DELETE_FAILURE] (state, data) {
      console.log('DOMAIN_DELETE_FAILURE')
    },
    [DOMAIN_DELETE_SUCCESS] (state, data) {
      console.log('DOMAIN_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/domain-list.js